<template>
  <div
    v-if="person"
    class="flex space-between items-center justify-center mb-14"
    :class="{
      'flex-col': failed,
    }"
  >
    <div
      class="w-24 h-24 md:w-36 md:h-36 cursor-pointer flex-0"
      :class="{
        '!w-72 !h-72 mb-5': failed,
      }"
      @click="
        $router.push(
          localePath({
            name: 'professionalPage',
            params: {
              professionalSeoName: person.seoName,
            },
          })
        )
      "
    >
      <PersonPictureSet
        :person="person"
        class="w-24 h-24 md:w-36 md:h-36 rounded-full"
        :class="{
          '!w-72 !h-72': failed,
        }"
      />
    </div>
    <template v-if="failed">
      <p class="text-center mb-10">
        <NuxtLink
          class="font-black text-center"
          target="_blank"
          :to="
            localePath({
              name: 'professionalPage',
              params: {
                professionalSeoName: person.seoName,
              },
            })
          "
        >
          {{ person.name }}
        </NuxtLink>
      </p>
      <div class="relative">
        <img
          class="hidden md:block absolute top-[-176px] left-[-150px]"
          v-lazy-load data-src="~/assets/img/curved-arrow.svg"
        />
        <JoszakiPill
          type="info"
          class="!font-black !rounded-lg text-lg md:!text-3xl !text-center mx-auto"
        >
          {{ $t("professionalRating.headline.areYouSure") }}
        </JoszakiPill>
      </div>
    </template>
    <template v-else>
      <p class="font-light flex-1 ml-2 text-2xl md:text-4xl">
        {{
          $t("professionalRating.headline.ratePerson", {
            mateName: person.name,
          })
        }}
      </p>
    </template>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useRating } from "~/components/_refactored/rating/useRating";
import defaultImageUrl from "@/assets/default-avatar.png";
import { useUserStore } from "~/stores/user";
import PersonPictureSet from "~/components/PersonPictureSet.vue";

export default {
  components: { PersonPictureSet },
  setup() {
    const rating = useRating();

    return { rating };
  },
  computed: {
    ...mapState(useUserStore, {
      me: "me",
    }),
    person() {
      return this.rating.state.person;
    },
    failed() {
      return this.rating.isProblemStep.value;
    },
  },
  methods: {
    noImage(e) {
      e.target.src = defaultImageUrl;
    },
  },
};
</script>
